import { BehaviorParameters } from 'rangeConfig/@types';
import { ProductType } from '@inter-ikea-storageone/range';
import { disableDarkModeIfNoLightsInScene } from 'rangeConfig/shared/utils/darkMode';
import { removeProducts } from 'rangeConfig/shared/utils/removeProducts';

const removeInnerLightsFromScene = ({
  coreApi,
  rootState: {
    layout: { darkScene },
    products: { inMarket: products }
  }
}: BehaviorParameters) => {
  const innerLights = coreApi.entities.getByProductTypes([
    ProductType.PAX_INNER_LIGHT,
    ProductType.PAX_INNER_LIGHT_OVERSIDAN
  ]);

  if (innerLights.length > 0) {
    removeProducts(innerLights, coreApi, products);
  }

  disableDarkModeIfNoLightsInScene(coreApi, darkScene);
};

export default removeInnerLightsFromScene;
